import { useEffect, useState } from "react";
import { Landmark, Linkedin, Instagram, Youtube } from "lucide-react";
import { API } from "../../lib/api";

const COLS = [
  {
    title: "Instituto",
    links: [
      { label: "Cursos", href: "#cursos" },
      { label: "Metodología", href: "#metodologia" },
      { label: "Instructora", href: "#instructora" },
      { label: "Precios", href: "#precios" },
    ],
  },
  {
    title: "Recursos",
    links: [
      { label: "Blog técnico", href: "#blog" },
      { label: "Simulador de retención", href: "#hero" },
      { label: "Contacto", href: "#contacto" },
    ],
  },
];

export const Footer = () => {
  const [healthy, setHealthy] = useState(null);

  useEffect(() => {
    fetch(`${API}/health`).then((r) => setHealthy(r.ok)).catch(() => setHealthy(false));
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="main-footer" className="border-t border-border pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg bg-gradient-to-br from-emerald-500 to-emerald-700 text-white flex items-center justify-center shadow-lg shadow-emerald-500/25">
                <Landmark className="w-5 h-5" />
              </span>
              <span className="font-display font-bold text-xl tracking-tight">CapacitaCon</span>
            </div>
            <p className="font-serif italic text-2xl sm:text-3xl text-muted-foreground mt-7 max-w-md leading-snug">
              "La contabilidad bien enseñada no es un gasto: es la palanca que mueve una carrera."
            </p>
            <div className="flex gap-3 mt-8">
              {[
                { icon: Linkedin, id: "social-linkedin", label: "LinkedIn" },
                { icon: Instagram, id: "social-instagram", label: "Instagram" },
                { icon: Youtube, id: "social-youtube", label: "YouTube" },
              ].map((s) => (
                <a key={s.id} href="#" data-testid={s.id} aria-label={s.label} onClick={(e) => e.preventDefault()} className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-emerald-500 hover:border-emerald-500/50 transition-colors">
                  <s.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <p className="text-xs font-mono uppercase tracking-[0.22em] text-muted-foreground mb-5">{col.title}</p>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`} onClick={(e) => go(e, l.href)} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <p className="text-xs font-mono uppercase tracking-[0.22em] text-muted-foreground mb-5">Estado</p>
            <div data-testid="footer-health-indicator" className="inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-xs">
              <span className={`w-2 h-2 rounded-full ${healthy === null ? "bg-amber-400" : healthy ? "bg-emerald-500 animate-pulse" : "bg-red-500"}`} />
              {healthy === null ? "Verificando..." : healthy ? "Plataforma en línea" : "Fuera de línea"}
            </div>
          </div>
        </div>

        <div className="mt-16 select-none pointer-events-none" aria-hidden="true">
          <p className="font-display font-extrabold tracking-tight text-[16vw] lg:text-[11rem] leading-none text-foreground/[0.04] whitespace-nowrap text-center">
            CAPACITACON
          </p>
        </div>

        <div className="mt-4 pt-8 border-t border-border flex flex-wrap items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>© 2026 CapacitaCon · Capacitación contable y administrativa</p>
          <p>Hecho con rigor técnico y mucho café</p>
        </div>
      </div>
    </footer>
  );
};
